export const pollingRequestStatuses = {
  inProgress: "inProgress",
  error: "InError",
  errorStatus2SMH: "Failed", // TY AB for different error statuses for the same request
  done: "Done",
} as const;
